import { useAuthStore } from "@/store/auth"
import { Redirect, Route, RouteProps, DefaultParams } from "wouter"

/**
 * RouteAuthenticated
 */
interface Props extends RouteProps {
  redirect?: string
}
export const RouteAuthenticated: React.FC<Props> = ({ redirect = "/sign-in", children, ...props }) => {
  const { authenticated } = useAuthStore()
  return (
    <>
      {authenticated ? (
        <Route {...props}>{G.isFunction(children) ? (params: DefaultParams) => children(params) : children}</Route>
      ) : (
        <Route {...props}>
          <Redirect to={redirect} />
        </Route>
      )}
    </>
  )
}
